import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { ClrCommonFormsModule, ClrIconModule, ClrInputModule } from "@clr/angular";
import {JsonPipe, NgIf} from "@angular/common";

import { environment as env } from "../../../../../environments/environment";

@Component({
  selector: 'app-edit-specification',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ClrCommonFormsModule,
    ClrIconModule,
    ClrInputModule,
    NgIf,
    JsonPipe
  ],
  templateUrl: './edit-specification.component.html',
  styleUrl: './edit-specification.component.sass'
})
export class EditSpecificationComponent {
  @Input() editSpecificationsForm!: FormGroup;
  @Input() technology: boolean = false;
  devMode: boolean;

  constructor() {
    this.devMode = env.stages.dev;
  }
}
